import React from 'react'
import {
    Container,
    Divider,
    HelpText,
    ContactText
} from './HelpSection.styles'

export interface HelpSectionProps {
    helpText: string
    contactText: string
    onContactClick?: () => void
}

const HelpSection: React.FC<HelpSectionProps> = ({
    helpText,
    contactText,
    onContactClick = () => {}
}) => {
    return (
        <Container>
            <Divider />
            <HelpText>
                {helpText}
            </HelpText>
            <ContactText
                onClick={onContactClick}
            >
                {contactText}
            </ContactText>
            <Divider />
        </Container>
    )
}

export default HelpSection
